import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_PROCESS_STATE = NS + 'CHANGE_PROCESS_STATE'

export const CHANGE_YEAR_WEEK = NS + 'CHANGE_YEAR_WEEK'

export const DELETE_YEAR_WEEK = NS + 'DELETE_YEAR_WEEK'

export const CHANGE_MODE = NS + 'CHANGE_MODE'

export const FIND_TRANSITION_REQUEST = NS + 'FIND_COHORT_REQUEST'
export const FIND_TRANSITION_SUCCESS = NS + 'FIND_COHORT_SUCCESS'
export const FIND_TRANSITION_ERROR = NS + 'FIND_COHORT_ERROR'



// WEBPACK FOOTER //
// ./src/modules/analytics/state/transition/type.js